<template>
	<div class="related-store-body">
		<div class="name-box">
			<div class="input-box">
				<span style="font-size:14px">商品名称：{{goodName}}</span>
				<!-- <el-input
					v-model=""
					class="name-input"
					disabled
					size="mini"
				></el-input> -->
			</div>
		</div>
		<Search @search='searchHandle'/>
		<div class="features-btn-box">
			<el-button type="primary" size='small' class="fx-big-btn" v-if="editDisable" plain @click="add">添加</el-button>
			<el-button type="primary" size='small' class="fx-big-btn" v-if="editDisable" plain @click="delMore">删除</el-button>
		</div>
		<MainTable
			@sizeChange='sizeChange'
			@pageChange='pageChange'
			@delStore='delStore'
			@delStoreMore='delStoreMore'
			:tableData='tableData'
			:totalCount='totalCount'
			:editDisable="editDisable"
		/>
		<el-dialog
			title="添加店铺"
			:visible.sync="dialogVisible"
			class="dialog-title"
			width="600px"
			:close-on-click-modal="false"
			><StoreDialog :visible.sync="dialogVisible" v-if="dialogVisible" @relateSuc='relateSuc'/>
		</el-dialog>
	</div>
</template>

<script>
import Search from '@/components/goodsManagement/relatedStore/Search'
import MainTable from '@/components/goodsManagement/relatedStore/MainTable'
import StoreDialog from '@/components/goodsManagement/relatedStore/StoreDialog'
export default {
	name: 'relatedStore',
	components: {
		Search,
		MainTable,
		StoreDialog
	},
	data () {
		return {
			dialogVisible: false,
			goodName: '',
			size: 20,
			page: 1,
			shopName: '',
			tableData: [],
			totalCount: 0,
			ids: '',
			editDisable: true
		}
	},
	created () {
		this.goodName = window.sessionStorage.getItem('goodName')
		this.getAuthority('02_0001_0000_00')
		this.getInfo()
	},
	methods: {
		getAuthority (id) {
			let params = {
				pId: id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result) {
					console.log(res)
					let a = res.data
					if (a.indexOf('02_0001_0001_00') > -1) {
						this.editDisable = true
					} else {
						if (window.sessionStorage.getItem('goodsAdd') === 'true') {
							this.editDisable = true
						} else {
							this.editDisable = false
						}
					}
				}
			})
		},
		add () {
			this.dialogVisible = true
		},
		searchHandle (value) {
			this.shopName = value
			this.getInfo()
		},
		sizeChange (value) {
			this.size = value
			this.getInfo()
		},
		pageChange (value) {
			this.page = value
			this.getInfo()
		},
		getInfo () {
			let params = {
				id: sessionStorage.getItem('goodsid'),
				shopName: this.shopName,
				comFlag: 0,
				size: this.size,
				page: this.page,
				order: 1,
				orderKey: ''
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getShopInfoOfProduct`,
				data: params
			}).then(res => {
				if (res.result) {
					this.tableData = res.data.recordList
					this.totalCount = res.data.recordCount
				}
			})
		},
		relateSuc () {
			this.dialogVisible = false
			this.getInfo()
		},
		delStore (value) {
			this.delStorePost(value)
		},
		delStoreMore (value) {
			this.ids = '' + value
		},
		delMore () {
			if (this.ids.length > 0) {
				this.$confirm('是否删除关联的门店？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					closeOnClickModal: false
				}).then(() => {
					this.delStorePost(this.ids)
				}).catch(() => {})
			} else {
				this.$message.error('请至少勾选一个店铺！')
			}
		},
		delStorePost (data) {
			let params = {
				ids: sessionStorage.getItem('goodsid'),
				shopIds: data
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/delShopRelationGoods`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('删除成功！')
					this.getInfo()
				} else {
					this.$message.error(res.msg)
					this.getInfo()
				}
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.related-store-body {
	height: 100%;
	display flex
	flex: 1
	flex-direction column
	.name-box{
		height :60px;
		line-height :60px;
		text-align :left;
		border-bottom 1px solid #dce2fd
		.input-box{
			margin-left :10px;
			overflow-x :hidden
			margin-bottom:10px
			.name-input {
				width: 150px;
				margin-right: 10px;
			}
			.select-box{
				width:150px;
				margin-right:10px;
			}
		}
	}
	.features-btn-box {
		text-align left
		padding 20px 0
		box-sizing border-box
	}
}
</style>
<style lang="stylus">
.related-store-body {
	.el-dialog {
		border-radius: 4px
	}
	.el-dialog__title {
		padding-left 10px
		border-left 5px solid var(--fx-primary-color)
	}
	.el-dialog__body {
		padding-top: 10px
	}
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
}
</style>
